export default {
  data() {
    return {
      memthed: {
        insert: {
          uid: "insert"
        }
      }
    }
  },

  computed: {
    epaperList: {
      get() {
        return this.$store.state.epaper.epaperList;
      }
    }
  },

  mounted() {
    this.$store.dispatch("epaper/getEpaperList");
  },

  methods: {
    clickEpaperList(list) {
      this.$router.push({
        name: "managerLetter",
        params: {
          uid: list.uid
        }
      });
    }
  },
}
